/*
 * authentication.js 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */

import { LOGIN_SUCCEEDED, LOGOUT } from '../actions/types';

const user = (state = { type: LOGOUT, data: null, initial: true}, action) => {

    switch (action.type) {

        case LOGIN_SUCCEEDED:
            return {
                type: action.type,
                data: action.user,
                initial: false
            };

        case LOGOUT:
            return {
                type: action.type,
                data: null,
                initial: false
            };

        default:
            return state;
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/authentication.js